<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-group element-type-part element-with-heading" id="part-1">
<div class="heading heading-container-group heading-size-group heading-format-group heading-alignment-fixed heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper"><span class="element-number-term">PART</span> <span class="element-number-number">ONE</span></h1>
</div>
</div>
</div>
</div>
<div class="text" id="part-1-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center">“The finest trick of the devil is to persuade you that he does not exist.”</p>
<p class="alignment-block-content alignment-block-content-center">— Charles Baudelaire</p>
<p class="alignment-block-content alignment-block-content-center">"Le Joueur généreux," Le Spleen de Paris</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part-001.vue?0b802c4c